// extracted by mini-css-extract-plugin
module.exports = {"container":"deviceSetting_container__1HK8l","dashed":"deviceSetting_dashed__2qVf_"};